export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    meta: { title: '仪表盘', icon: 'el-icon-s-data' }
  },
  {
    name: 'User',
    path: '/user',
    meta: { title: '用户管理', icon: 'el-icon-user', alwaysShow: true },
    children: [
      { name: 'UserList', path: '/user/list', meta: { title: '用户列表' } }
    ]
  },
  {
    name: 'Group',
    path: '/group',
    meta: { title: '群组管理', icon: 'el-icon-s-tools', alwaysShow: true },
    children: [
      { name: 'GroupList', path: '/group/list', meta: { title: '群组列表' } }
    ]
  },
  {
    name: 'Bill',
    path: '/bill',
    meta: { title: '账单管理', icon: 'el-icon-s-finance', alwaysShow: true },
    children: [
      { name: 'BillList', path: '/bill/list', meta: { title: '账单列表' } }
    ]
  },
  {
    name: 'Permission',
    path: '/permission',
    meta: { title: '权限管理', icon: 'el-icon-lock', alwaysShow: true },
    children: [
      { name: 'PermissionList', path: '/permission/list', meta: { title: '权限列表' } }
    ]
  },
  {
    name: 'Bot',
    path: '/bot',
    meta: { title: 'Bot 管理', icon: 'el-icon-s-platform', alwaysShow: true },
    children: [
      { name: 'BotList', path: '/bot/list', meta: { title: 'Bot 列表' } }
    ]
  }
]
